import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button } from './Button';
export function StormBanner() {
  return <section className="w-full bg-gradient-to-r from-brand-bg to-emerald-950 py-6 md:py-8" data-id="element-99">
      <div className="container mx-auto px-6" data-id="element-100">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-101">
          <div className="flex items-start md:items-center gap-4 text-white" data-id="element-102">
            <AlertTriangle className="w-6 h-6 md:w-8 md:h-8 text-brand-orange flex-shrink-0 mt-1 md:mt-0" data-id="element-103" />
            <p className="font-body text-sm md:text-base lg:text-lg" data-id="element-104">
              <span className="font-bold" data-id="element-105">Storm Season Is Here.</span> Untrimmed
              trees are the #1 cause of property damage during high winds. We're
              booking up fast.
            </p>
          </div>
          <Button className="bg-brand-orange hover:bg-brand-orange/90 text-white font-body font-semibold h-12 px-6 whitespace-nowrap w-full md:w-auto min-h-[48px]" data-id="element-106">
            Schedule Before It's Too Late
          </Button>
        </div>
      </div>
    </section>;
}